import "./IvError.css";
import React, { useState , useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Container, Row, Col, Form, Button, Table, Modal } from 'react-bootstrap';

// 비트맵 정의
const AlarmModalData = {
  1: {
    title: "0x002F Mode 상태 정보",
    rows: [
      { bit: "Bit15", desc: "Fault", code: "0x8000" },
      { bit: "Bit14", desc: "Check", code: "0x4000" },
      { bit: "Bit13", desc: "Standby", code: "0x2000" },
      { bit: "Bit12", desc: "Running", code: "0x1000" },
      { bit: "Bit11", desc: "Derate", code: "0x0800" },
      { bit: "Bit10", desc: "", code: "" },
      { bit: "Bit9", desc: "", code: "" },
      { bit: "Bit8", desc: "", code: "" },
      { bit: "Bit7", desc: "", code: "" },
      { bit: "Bit6", desc: "", code: "" },
      { bit: "Bit5", desc: "", code: "" },
      { bit: "Bit4", desc: "", code: "" },
      { bit: "Bit3", desc: "", code: "" },
      { bit: "Bit2", desc: "", code: "" },
      { bit: "Bit1", desc: "", code: "" },
      { bit: "Bit0", desc: "", code: "" }
    ]
  },

  2: {
    title: "0x0036 Fault0 상태 정보",
    rows: [
      { bit: "Bit15", desc: "Inverter current bias", code: "IntFanErr" },
      { bit: "Bit14", desc: "Over-temperature protection", code: "TempOver" },
      { bit: "Bit13", desc: "Grid relay protection", code: "Protect0020" },
      { bit: "Bit12", desc: "Out of phase", code: "GridV.OutLim" },
      { bit: "Bit11", desc: "Grid frequency is low", code: "GridF.OutLim" },
      { bit: "Bit10", desc: "Grid frequency is high", code: "GridF.OutLim" },
      { bit: "Bit9",  desc: "High inverter current", code: "Protect0030" },
      { bit: "Bit8",  desc: "Grid phase voltage overrun", code: "GridV.OutLim" },
      { bit: "Bit7",  desc: "Power line voltage exceeds the limit", code: "GridV.OutLim" },
      { bit: "Bit6",  desc: "PV1 high current", code: "Protect0040" },
      { bit: "Bit5",  desc: "Reserved", code: "" },
      { bit: "Bit4",  desc: "Inverter soft start overtime", code: "Protect0050" },
      { bit: "Bit3",  desc: "Bus soft start overtime", code: "Protect0060" },
      { bit: "Bit2",  desc: "Bus voltage difference is high", code: "Protect0070" },
      { bit: "Bit1",  desc: "Reserved", code: "" },
      { bit: "Bit0",  desc: "Bus voltage and high", code: "Protect0090" }
    ]
  },
  3: {
    title: "0x0037 Fault1 상태 정보",
    rows: [
      { bit: "Bit15", desc: "Leakage current sensor is abnormal", code: "Protect0100" },
      { bit: "Bit14", desc: "Bus hardware overvoltage", code: "Protect0110" },
      { bit: "Bit13", desc: "Reserved", code: "" },
      { bit: "Bit12", desc: "Power module protection", code: "Protect0120" },
      { bit: "Bit11", desc: "Inverter current imbalance", code: "Protect0130" },
      { bit: "Bit10", desc: "Reserved", code: "" },
      { bit: "Bit9", desc: "Grid voltage is unbalanced", code: "GridV.OutLim" },
      { bit: "Bit8", desc: "Inverter hardware overcurrent", code: "Protect0140" },
      { bit: "Bit7", desc: "MCU protection", code: "Protect0150" },
      { bit: "Bit6", desc: "Reserved", code: "" },
      { bit: "Bit5", desc: "Abnormal frequency selection", code: "Protect0160" },
      { bit: "Bit4", desc: "Leakage current is too high", code: "GFCIErr" },
      { bit: "Bit3", desc: "Insulation resistance is too low", code: "IsolationErr" },
      { bit: "Bit2", desc: "DCI current is too high", code: "Protect0170" },
      { bit: "Bit1", desc: "DCI current bias", code: "Protect0180" },
      { bit: "Bit0", desc: "Reserved", code: "" }
    ]
  },
  4: {
    title: "0x0038 Fault2 상태 정보",
    rows: [
      { bit: "Bit15", desc: "Reserved", code: "" },
      { bit: "Bit14", desc: "Reserved", code: "" },
      { bit: "Bit13", desc: "Reserved", code: "" },
      { bit: "Bit12", desc: "PV3 voltage is too high", code: "PV3VoltOver" },
      { bit: "Bit11", desc: "PV3 input reverse", code: "PV3Reverse" },
      { bit: "Bit10", desc: "PV1 voltage is too high", code: "PV1VoltOver" },
      { bit: "Bit9",  desc: "PV1 input is reversed", code: "PV1Reverse" },
      { bit: "Bit8",  desc: "Reserved", code: "" },
      { bit: "Bit7",  desc: "Power inverter open-loop self-test", code: "Protect0230" },
      { bit: "Bit6",  desc: "PV source input is abnormal", code: "Protect0260" },
      { bit: "Bit5",  desc: "PV2 voltage is too high", code: "PV2VoltOver" },
      { bit: "Bit4",  desc: "PV2 input overcurrent", code: "Protect0240" },
      { bit: "Bit3",  desc: "PV2 input is reversed", code: "PV2Reverse" },
      { bit: "Bit2",  desc: "Reserved", code: "" },
      { bit: "Bit1",  desc: "Internal hardware error", code: "Protect0210" },
      { bit: "Bit0",  desc: "Reserved", code: "" }
    ]
  },
  5: {
    title: "0x0039 Fault3 상태 정보",
    rows: [
      { bit: "Bit15", desc: "ARC protection", code: "ARC Protect" },
      { bit: "Bit14", desc: "Reserved", code: "" },
      { bit: "Bit13", desc: "Hardware driver power supply is abnormal", code: "Protect0330" },
      { bit: "Bit12", desc: "Reserved", code: "" },
      { bit: "Bit11", desc: "Reserved", code: "" },
      { bit: "Bit10", desc: "Reserved", code: "" },
      { bit: "Bit9",  desc: "Reserved", code: "" },
      { bit: "Bit8",  desc: "Reserved", code: "" },
      { bit: "Bit7",  desc: "Reserved", code: "" },
      { bit: "Bit6",  desc: "Reserved", code: "" },
      { bit: "Bit5",  desc: "Reserved", code: "" },
      { bit: "Bit4",  desc: "Reserved", code: "" },
      { bit: "Bit3",  desc: "Reserved", code: "" },
      { bit: "Bit2",  desc: "Reserved", code: "" },
      { bit: "Bit1",  desc: "Reserved", code: "" },
      { bit: "Bit0",  desc: "Reserved", code: "" }
    ]
  },
  6: {
    title: "0x003A Fault4 상태 정보",
    rows: [
      { bit: "Bit15", desc: "Phase-to-ground voltage anomaly protection", code: "Protect0470" },
      { bit: "Bit14", desc: "", code: "" },
      { bit: "Bit13", desc: "", code: "" },
      { bit: "Bit12", desc: "", code: "" },
      { bit: "Bit11", desc: "", code: "" },
      { bit: "Bit10", desc: "CPLD clock is abnormal", code: "Protect0520" },
      { bit: "Bit9",  desc: "CPLD program version is abnormal", code: "Protect0530" },
      { bit: "Bit8",  desc: "Abnormal product model", code: "Protect0540" },
      { bit: "Bit7",  desc: "Bst hardware overcurrent", code: "Protect0550" },
      { bit: "Bit6",  desc: "Control board voltage is low 3.3V", code: "Protect0560" },
      { bit: "Bit5",  desc: "Capture PLL lock exception", code: "Protect0570" },
      { bit: "Bit4",  desc: "PV3 input overcurrent", code: "Protect0580" },
      { bit: "Bit3",  desc: "Battery overboard", code: "Protect0590" },
      { bit: "Bit2",  desc: "Arc board failure", code: "Arcboard Err" },
      { bit: "Bit1",  desc: "Steady-state GFCI protection", code: "Protect0610" },
      { bit: "Bit0",  desc: "Control board voltage is low 5V", code: "Protect0620" }
    ]
  },
  7: {
    title: "0x0035 Warn 상태 정보",
    rows: [
      { bit: "Bit15", desc: "Reserved", code: "" },
      { bit: "Bit14", desc: "Reserved", code: "" },
      { bit: "Bit13", desc: "PVStrErr", code: "PVStrErr" },
      { bit: "Bit12", desc: "Pid Box communication fail", code: "Pid Box CommErr" },
      { bit: "Bit11", desc: "Pid Box fail", code: "Pid Box Err" },
      { bit: "Bit10", desc: "AC side MOV is abnormal", code: "Warn0100" },
      { bit: "Bit9",  desc: "Reserved", code: "" },
      { bit: "Bit8",  desc: "Reserved", code: "" },
      { bit: "Bit7",  desc: "AC side lightning arrester is abnormal", code: "Warn0070" },
      { bit: "Bit6",  desc: "Reserved", code: "" },
      { bit: "Bit5",  desc: "Temperature sensor is abnormal", code: "Warn0050" },
      { bit: "Bit4",  desc: "DC side lightning protection device is abnormal", code: "Warn0040" },
      { bit: "Bit3",  desc: "Eeprom problem", code: "Warn0030" },
      { bit: "Bit2",  desc: "Internal communication failed", code: "CommErr" },
      { bit: "Bit1",  desc: "Internal fan alarm", code: "IntFanErr" },
      { bit: "Bit0",  desc: "External fan alarm", code: "ExtFanErr" }
    ]
  },
  8: {
    title: "0x0034 PFault 상태 정보",
    rows: [
      { bit: "Bit15", desc: "Control board voltage and drive power failure", code: "Fault0160" },
      { bit: "Bit14", desc: "Open-loop self-test failed failure", code: "Fault0150" },
      { bit: "Bit13", desc: "Internal hardware failure", code: "Fault0140" },
      { bit: "Bit12", desc: "Permanent power module failure", code: "Fault0010" },
      { bit: "Bit11", desc: "Bus hardware overvoltage fault", code: "Fault0020" },
      { bit: "Bit10", desc: "", code: "" },
      { bit: "Bit9",  desc: "", code: "" },
      { bit: "Bit8",  desc: "Inverter hardware overcurrent fault", code: "Fault0050" },
      { bit: "Bit7",  desc: "CPLD clock is faulty", code: "Fault0060" },
      { bit: "Bit6",  desc: "DCI is too high", code: "Fault0070" },
      { bit: "Bit5",  desc: "Bst Hardware overcurrent fault", code: "Fault0080" },
      { bit: "Bit4",  desc: "Steady-state GFCI failure", code: "Fault0090" },
      { bit: "Bit3",  desc: "Relay failure", code: "Fault0100" },
      { bit: "Bit2",  desc: "Bus high failure", code: "Fault0110" },
      { bit: "Bit1",  desc: "", code: "" },
      { bit: "Bit0",  desc: "Bus and high fault", code: "Fault0130" }
    ]
  },
};

const IvError = ({ SelInverter }) => {
  const Iv_list = useSelector(state => state.Iv_list || {});
  const ivData = useSelector(state => state.ivData || {});
  const [index, setIndex] = useState(null);
  const [openModalNum, setOpenModalNum] = useState(null);
  const closeModal = () => setOpenModalNum(null);

  useEffect(() => {
    if (Iv_list.seq && Array.isArray(Iv_list.seq)) {
      const foundIndex = Iv_list.seq.findIndex(seq => seq === SelInverter);
      if (foundIndex !== -1) {
        setIndex(foundIndex);
      }
    }
  }, [Iv_list, SelInverter]);

  const parseBitFlags = (value) => {
    const flags = {};
    for (let i = 15; i >= 0; i--) {
      flags[`Bit${i}`] = (value & (1 << i)) !== 0;
    }
    return flags;
  };

  const isStatusAbnormal = (registerKey, value) => {
    if (typeof value !== 'number') return false;
    const bin = value.toString(2).padStart(16, '0');
    if (registerKey === 'mode') {
      for (let i = 0; i < 16; i++) {
        if (i !== 3 && bin[i] === '1') return true;
      }
      return false;
    } else {
      return bin.includes('1');
    }
  };

  const renderModalContent = () => {
    const modal = AlarmModalData[openModalNum];
    if (!modal) return null;

    const getValue = (key) =>
      Array.isArray(ivData[key]) ? ivData[key]?.[index] : ivData[key];

    const valueMap = {
      1: ivData.mode,
      2: ivData.fault0,
      3: ivData.fault1,
      4: ivData.fault2,
      5: ivData.fault3,
      6: ivData.fault4,
      7: ivData.Warn,
      8: ivData.Pfault,
    };

    // console.log("비트맵")


    const rawValue = valueMap[openModalNum];
    const selectedValue = Array.isArray(rawValue) ? rawValue[index] : rawValue;
    const activeBits = parseBitFlags(selectedValue);
    



    return (
      <>
        <Modal.Header closeButton>
          <Modal.Title>{modal.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered size="sm">
            <tbody>
              {modal.rows.map((row, idx) => {
                const isActive = activeBits[row.bit.trim()];

                return (
                  <tr key={idx} className={isActive ? "active-row" : ""}>
                    <td>{row.bit}</td>
                    <td>{row.desc}</td>
                    <td>{row.code}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>닫기</Button>
        </Modal.Footer>
      </>
    );
  };

  return (
    <div className="status-list-container">
      <div className="status-list">
        {[
          { label: "0x002F (Mode)", key: "mode", num: 1 },
          { label: "0x0036 (Fault0)", key: "fault0", num: 2 },
          { label: "0x0037 (Fault1)", key: "fault1", num: 3 },
          { label: "0x0038 (Fault2)", key: "fault2", num: 4 },
          { label: "0x0039 (Fault3)", key: "fault3", num: 5 },
          { label: "0x003A (Fault4)", key: "fault4", num: 6 },
          { label: "0x0035 (Warn)", key: "Warn", num: 7 },
          { label: "0x0034 (PFault)", key: "Pfault", num: 8 },
        ].map(({ label, key, num }) => {
          const value = Array.isArray(ivData[key]) ? ivData[key]?.[index] : ivData[key];
          // console.log("원본 value 타입:", typeof value, "값:", value);
          const isAbnormal = isStatusAbnormal(key, value);
          return (
            <div key={num} className="status-item">
              <span className="status-value">{label}: {value}</span>
              <button onClick={() => setOpenModalNum(num)}>
                <span className={isAbnormal ? 'blinking-icon' : ''}>
                  {isAbnormal ? '🔴' : '🟢'}
                </span>
              </button>
            </div>
          );
        })}
      </div>

      {openModalNum !== null && (
        <Modal show onHide={closeModal} size="lg">
          {renderModalContent()}
        </Modal>
      )}
    </div>
  );
};

export default IvError;

